import { LoginBrandingPanel } from "../components/auth/LoginBrandingPanel";
import { authCardClassName } from "../components/auth/authInputStyles";
import { useAuth } from "../context/AuthContext";

export function AuthEntryPage() {
  const { launchError } = useAuth();

  return (
    <div className="flex min-h-screen flex-col bg-[#f8f9ff] lg:flex-row">
      <LoginBrandingPanel />
      <div className="flex min-h-screen flex-1 items-center justify-center bg-[#f8f9ff] px-4 py-10 sm:px-8">
        <div className={authCardClassName}>
          <h1 className="font-inter text-xl font-bold tracking-[-0.5px] text-[#1f2937]">
            Open iTEMA from TutorCloud
          </h1>
          <p className="mt-2 font-inter text-sm leading-[22px] text-[#444651]">
            Sign in and new accounts are turned off on this page. Open iTEMA
            from the TutorCloud teacher sidebar.
          </p>
          {launchError ? (
            <p
              className="mt-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 font-inter text-sm text-amber-900"
              role="alert"
            >
              {launchError}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
